import { useAtom } from "jotai";
import { atomWithStorage } from "jotai/utils";

import { type TradePanelTab } from "#/types/tradePanel";

export const tradePanelTabAtom = atomWithStorage<TradePanelTab>(
  "tradePanelTab",
  "options",
);

export const useTradePanelTab = () => {
  const [tradePanelTab, setTradePanelTab] = useAtom(tradePanelTabAtom);

  const isOptions = tradePanelTab === "options";
  const isPerps = tradePanelTab === "perps";
  const isCombo = tradePanelTab === "combo";

  return {
    isOptions,
    isPerps,
    isCombo,
    tradePanelTab,
    setTradePanelTab,
  };
};
